import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'general-behavior',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './general-behavior.component.html',
  styleUrl: './general-behavior.component.css'
})
export class GeneralBehaviorComponent implements OnInit, OnChanges {

  @Input() studentInterviewData: any;
  @Output() onSaveSection5 = new EventEmitter<any>();

  generalBehaviorForm: FormGroup = new FormGroup([]);
  questionsList = [
    {
      question: 'Dress: *',
      formControlName: 'dress',
      answers: ['Eccentric', 'Dirty', 'Neat', 'Untidy'],
      defaultValue: 'Eccentric'
    },
    {
      question: 'Posture: *',
      formControlName: 'posture',
      answers: ['Erect', 'Tense', 'Relaxed', 'Laying Down'],
      defaultValue: 'Erect'
    },
    {
      question: 'Facial Expression: *',
      formControlName: 'facial_expression',
      answers: ['Fixed', 'Changing', 'Angry', 'Perplexed', 'Sad', 'Happy', 'Suspicious'],
      defaultValue: 'Fixed'
    },
    {
      question: 'Physical Activity: *',
      formControlName: 'physical_activity',
      answers: ['Normal', 'Under-active', 'Over-active'],
      defaultValue: 'Normal'
    }
  ];
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studentInterviewData'] && this.studentInterviewData) {
      this.initializeForm();
    }
  }

  onCheckboxChange(e: any, controlName: string, value: string) {
    const currentValues = new Set(this.generalBehaviorForm.get(controlName)!.value.split(', ').filter((v: string) => v));
    if (e.target.checked) {
      currentValues.add(value);
    } else {
      currentValues.delete(value);
    }
    this.generalBehaviorForm.get(controlName)?.setValue(Array.from(currentValues).join(', '));
  }

  private initializeForm() {
    const group: any = {};
    
    this.questionsList.forEach(question => {
      if (this.studentInterviewData?.[question.formControlName]) {
        const value = this.studentInterviewData[question.formControlName];
        if (value && value.includes(', ')) {
          group[question.formControlName] = new FormControl(value.split(', ').join(', '));
        } else {
          group[question.formControlName] = new FormControl(value || question.defaultValue, Validators.required);
        }
      } else {
        group[question.formControlName] = new FormControl(question.defaultValue, Validators.required);
      }
    });
  
    this.generalBehaviorForm = new FormGroup(group);
  }
  

  
  saveSupportResources(): void {
    if (this.generalBehaviorForm.valid) {
      this.onSaveSection5.emit(this.generalBehaviorForm.value);
    }
  }

}
